import { ContractChange } from './contract-change.model';
import { formTypes } from 'app/form/form.constants';
export class ContractChangeClosure extends ContractChange {

    reason: string;
    comment: string;
    userType: string;

    constructor(formIndex: number = null, form?: any) {
        super(formIndex, form);
        this.init();
    }

    init() {
        super.init();
        this.type = formTypes.contractClosure.abbrev;
    }
}